export default __webpack_public_path__ + "static/media/leafLogo.0e4c26fb.svg";